<template>
  <admin-layout menu="Vagas">
    <div ref="row_default" class="row mb-4">
      <div class="col-lg-7 py-2">
        <h5 class="mr-2 font-weight-bold d-inline">KANBAN DA VAGA</h5>
        <h5 class="color-primary d-inline" style="text-transform: uppercase">
          {{ job.title }}
        </h5>
      </div>
      <div class="col-lg-5">
        <div v-show="!new_column" class="create_column">
          <button
            class="btn full btn-primary radius-0 f13 p-2"
            type="button"
            @click="enable_create_column"
          >
            <span> ADICIONAR COLUNA </span>
          </button>
        </div>
        <div v-show="new_column" class="create_column">
          <div class="input-group">
            <input
              ref="column_name"
              v-model="column_name"
              aria-describedby="basic-addon2"
              aria-label="nome da coluna"
              autofocus
              class="form-control"
              placeholder="Nome "
              type="text"
              v-on:keyup.enter="createColumn"
            />
            <div class="input-group-append">
              <button
                class="btn btn-success"
                type="button"
                @click="createColumn"
              >
                <font-awesome-icon class="mr-2" icon="check" />
              </button>
              <button
                class="btn btn-danger"
                type="button"
                @click="new_column = false"
              >
                <font-awesome-icon class="mr-2" icon="times" />
              </button>
            </div>
          </div>
        </div>
        <div class="py-2">
          <inertia-link
            :href="`/recruiters/jobs/${job.id}/applies`"
            class="btn right pointer mr-2 color-primary"
            style="margin-top: -5px"
            type="button"
          >
            <font-awesome-icon class="f20" icon="list-ul" />
          </inertia-link>
          <button
            v-clipboard:copy="job_url"
            v-clipboard:success="onCopy"
            class="btn right pointer mr-2 color-primary"
            style="margin-top: -5px"
            type="button"
          >
            <font-awesome-icon class="f20" icon="link" />
          </button>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-lg-3 col-md-4 col-xs-12">
        <div class="bg-aqua px-3">
          <span class="f30 font-weight-bold">{{ total_apply }}</span>
          <span class="f12 font-weight-bold">CANDIDATOS(AS)</span>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-xs-12">
        <div class="px-3 color-white" style="background-color: #241a3f">
          <span class="f30 font-weight-bold">{{ total_selected }}</span>
          <span class="f12 font-weight-bold">QUALIFICADOS(AS)</span>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-xs-12">
        <div class="bg-aqua px-3">
          <span class="f30 font-weight-bold">{{ reproved }}</span>
          <span class="f12 font-weight-bold">REPROVADOS(AS)</span>
        </div>
      </div>
    </div>
    <draggable
      :disabled="!can_dragg"
      :list="selective_processes"
      class="list-group direction_row list_block"
      ghost-class="ghost"
      v-bind="dragOptions"
      @change="changeColumn"
    >
      <transition-group
        ref="transition_div"
        :style="`width: ${width_kanban}px`"
        class="transition_column"
        name="flip-list"
        type="transition"
      >
        <div
          v-for="(selective_process, index) in selective_processes"
          :key="selective_process.id"
          :style="{ backgroundColor: background_color(selective_process) }"
          class="column_kanban painel-candidate mr-3"
        >
          <HeaderColumnKanban
            :gallery="gallery"
            :index="index"
            :questions="questions[selective_process.position]"
            :selective_process="selective_process"
            :total_in_column="total_per_column[selective_process.position] || 0"
            style="text-transform: uppercase"
          />
          <div
            class="candidate-list-container"
            @scroll="handleScroll($event, selective_process, index)"
          >
            <draggable
              :list="applies[selective_process.position]"
              class="list-group candidate-list"
              ghost-class="ghost"
              group="candidates"
              v-bind="dragOptions"
              @change="moveCandidate($event, selective_process)"
            >
              <transition-group
                class="direction_column"
                name="flip-list"
                type="transition"
              >
                <div
                  v-for="(apply, i) in applies[selective_process.position]"
                  :key="apply.id"
                  :style="{
                    borderRightColor: apply.tag_color,
                    borderLeftWidth: 4,
                  }"
                  class="bg-white mt-2 card_candidate"
                  @click="
                    show(
                      apply.id,
                      apply.candidate.id,
                      i,
                      applies[selective_process.position]
                    )
                  "
                >
                  <div class="img_card_block">
                    <img
                      :src="apply.image || '/images/avatar.png'"
                      class="img_card mr-1"
                    />
                  </div>
                  <div class="text_card">
                    <span>
                      {{ apply.candidate.name }}
                    </span>
                    <StarRating
                      :rating="apply.rating_agg ? apply.rating_agg : 0"
                      :read-only="true"
                      :show-rating="false"
                      active-color="#9472F8"
                      v-bind:max-rating="5"
                      v-bind:star-size="15"
                    ></StarRating>

                    <span class="big-small-text">{{
                      apply.candidate.email
                    }}</span>
                    <div
                      v-if="apply.tag_name"
                      :style="`background-color: ${
                        apply.tag_color || 'null'
                      }; text-shadow: 0px 0px 3px black; height: 23px`"
                      class="color-white center pt-1 font-weight-bold"
                    >
                      <p style="text-transform: uppercase">
                        {{
                          apply.tag_name != null
                            ? apply.tag_name
                            : "Sem Etiqueta"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div
              v-if="loading[index]"
              class="loading-indicator text-center py-2"
            >
              <small class="text-muted">Carregando mais candidatos...</small>
            </div>
          </div>
        </div>
      </transition-group>
    </draggable>
  </admin-layout>
</template>

<script>
import ApplyShow from "@/Recruiters/Applies/Show.vue";
import StarRating from "vue-star-rating";
import HeaderColumnKanban from "components/HeaderColumnKanban.vue";
import ComfirmFeedback from "@/Recruiters/Feedback/Confirm.vue";
import ConfirmQuestions from "@/Recruiters/SelectedQuestions/Confirm.vue";
import draggable from "vuedraggable";

export default {
  props: ["job", "job_url", "gallery", "recruiter_id"],
  components: { draggable, HeaderColumnKanban, StarRating },
  data: () => ({
    can_dragg: true,
    width_kanban: 990,
    new_column: false,
    column_name: "",
    selective_processes: [],
    applies: [],
    questions: [],
    total_apply: 0,
    total_selected: 0,
    reproved: 0,
    total_per_column: [],
    page: [],
    loading: [],
    hasMore: [],
    loadingKanban: false,
    thumbnailCache: new Map(),
  }),
  mounted() {
    this.make();
    this.width_kanban = this.$refs.row_default.clientWidth;
    eventBus.$on("remove_column", (index) => {
      this.selective_processes.splice(index, 1);
    });
    eventBus.$on("makeKanban", (field) => {
      this.make();
    });
    eventBus.$on("setDraggable", (value) => {
      this.can_dragg = value;
    });

    eventBus.$on("clouseModalEditFeedback", (field) => {
      this.$modal.hideAll();
      this.make();
    });
  },

  methods: {
    preloadThumbnails() {
      this.applies.forEach((columnApplies, columnIndex) => {
        if (columnApplies && columnApplies.length > 0) {
          this.preloadColumnThumbnails(columnApplies);
        }
      });
    },
    preloadColumnThumbnails(applies) {
      applies.forEach((apply) => {
        if (apply.image && !this.thumbnailCache.has(apply.image)) {
          const img = new Image();
          img.src = apply.image;
          this.thumbnailCache.set(apply.image, true);
        }
      });
    },
    getLazyImage(imageUrl) {
      if (!imageUrl) return '/images/avatar.png';

      if (this.thumbnailCache.has(imageUrl)) {
        return imageUrl;
      }

      return '/images/avatar.png';
    },
    haveRightAnswer(question) {
      let excluded_types = [0, 1, 4];
      if (excluded_types.includes(question.response_type)) return false;

      let choices = question.choices;
      if (choices.correctAnswer && choices.correctAnswer != "any") return true;

      if (question.response_type == 2) {
        let rightOptions = choices.options.filter((el) => el.rightAnswer);

        return (
          rightOptions.length > 0 &&
          rightOptions.length != choices.options.length
        );
      }

      return false;
    },
    background_color(selective_process) {
      if (selective_process.status == 1) return "#d4dcdf";
      if (selective_process.status == 3) return "#dbeac1";

      return "#ededed";
    },
    show(apply_id, candidate_id, index, applies) {
      let questions_count = this.job.questions.filter((question) =>
        this.haveRightAnswer(question)
      ).length;

      let percentage = Math.floor(
        (applies[index].point * 100) / questions_count
      );

      this.$modal.show(
        ApplyShow,
        {
          index: index,
          applies: applies,
          job_id: this.job.id,
          apply_id: apply_id,
          job_name: this.job.title,
          candidate_id: candidate_id,
          recruiter_id: this.recruiter_id,
          talent_bank_id: applies[index].talent_bank_id,
          hitsPercentage: percentage,
        },
        {
          width: "90%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            eventBus.$emit("setDraggable", true);
            this.make();
          },
        }
      );
    },
    make() {
      if (this.loadingKanban) return;
      this.loadingKanban = true;

      axios
        .get(`/recruiters/jobs/${this.job.id}/kanban.json`)
        .then((response) => {
          this.selective_processes = response.data.selective_processes;
          this.applies = response.data.applies;
          this.questions = response.data.questions;
          this.total_apply = response.data.total_apply;
          this.total_selected = response.data.total_selected;
          this.reproved = response.data.reproved;
          this.total_per_column = response.data.total_per_column || [];

          this.page = this.selective_processes.map(() => 1);
          this.loading = this.selective_processes.map(() => false);
          this.hasMore = this.selective_processes.map((sp) => {
            const position = sp.position;
            const currentCount = this.applies[position]
              ? this.applies[position].length
              : 0;
            const totalCount = this.total_per_column[position] || 0;
            return currentCount < totalCount;
          });

          this.preloadThumbnails();
        })
        .finally(() => {
          this.loadingKanban = false;
        });
    },
    confirmFeedback(
      feedback,
      selective_process,
      candidate,
      apply,
      questions = false,
      bigfive
    ) {
      this.$modal.show(
        ComfirmFeedback,
        {
          status: true,
          candidates: [candidate],
          feedback: feedback,
          feedback_selective_process: {
            selective_process_id: selective_process.id,
          },
        },
        {
          width: "55%",
          height: "auto",
          scrollable: true,
          // dynamicDefaults: {
          clickToClose: false,
          // }
        },
        {
          closed: (event) => {
            if (selective_process.status === 1) return;
            if (questions || bigfive)
              this.openConfirmQuestions(selective_process.uid, apply, bigfive);
          },
        }
      );
    },
    openConfirmQuestions(selective_process_uid, apply, bigfive) {
      this.can_dragg = false;

      this.$modal.show(
        ConfirmQuestions,
        {
          selective_process_uid,
          applies: [{ ...apply.candidate, ...apply }],
          bigfive,
        },
        {
          width: "55%",
          height: "auto",
          scrollable: true,
          clickToClose: false,
        },
        {
          "before-close": (event) => {
            eventBus.$emit("setDraggable", true);
          },
        }
      );
    },
    moveCandidate(element, column) {
      if (element["added"] || element["moved"]) {
        let element_now = element["moved"];
        if (element["added"]) element_now = element["added"];

        axios
          .put(`/recruiters/jobs/${this.job.id}/kanban/move_candidate`, {
            kanban: {
              apply_id: element_now.element.id,
              position: element_now["newIndex"],
              selective_process_id: column.id,
            },
          })
          .then((response) => {
            this.make();
            if (response.data.feedback) {
              this.confirmFeedback(
                response.data.feedback,
                column,
                response.data.candidate,
                element_now.element,
                response.data.questions,
                response.data.bigfive
              );

              return;
            }
            if (response.data.questions || response.data.bigfive) {
              if (column.status === 1) return;
              this.openConfirmQuestions(
                column.uid,
                element_now.element,
                response.data.bigfive
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    handleScroll(event, selective_process, index) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (
        scrollHeight - scrollTop <= clientHeight + 1 &&
        !this.loading[index] &&
        this.hasMore[index]
      ) {
        this.loadMoreApplies(selective_process, index);
      }
    },
    loadMoreApplies(selective_process, index) {
      this.$set(this.loading, index, true);
      const nextPage = this.page[index] + 1;

      axios
        .get(
          `/recruiters/jobs/${this.job.id}/kanban/column_applies?selective_process_id=${selective_process.id}&page=${nextPage}`
        )
        .then((response) => {
          const newApplies = response.data.applies;
          const position = selective_process.position;

          if (newApplies && newApplies.length > 0) {
            this.applies[position].push(...newApplies);
            this.$set(this.page, index, nextPage);

            this.preloadColumnThumbnails(newApplies);
          }

          const currentCount = this.applies[position].length;
          const totalCount = this.total_per_column[position] || 0;
          if (currentCount >= totalCount) {
            this.$set(this.hasMore, index, false);
          }
        })
        .catch((error) => {
          console.error("Erro ao carregar mais candidatos:", error);
        })
        .finally(() => {
          this.$set(this.loading, index, false);
        });
    },

    onCopy: function (e) {
      this.$toast.success("LINK COPIADO COM SUCESSP");
    },
    changeColumn: function (e) {
      axios.put(`/recruiters/jobs/${this.job.id}/kanban/columns`, {
        kanban: { columns: this.selective_processes },
      });
    },
    enable_create_column() {
      this.new_column = true;
      this.$refs.column_name.focus();
    },
    createColumn() {
      axios
        .post(`/recruiters/jobs/${this.job.id}/kanban/columns`, {
          kanban: { column_name: this.column_name },
        })
        .then((response) => {
          this.make();
          this.new_column = false;
          this.column_name = "";
        });
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
};
</script>

<style scoped>
.candidate-list-container {
  height: calc(100vh - 350px);
  overflow-y: auto;
  padding-right: 5px;
}

.candidate-list {
  min-height: 100%;
}

.loading-indicator {
  padding: 10px;
  color: #6c757d;
  font-size: 12px;
}

.candidate-list-container::-webkit-scrollbar {
  width: 6px;
}

.candidate-list-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.candidate-list-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.candidate-list-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
